export default __webpack_public_path__ + "static/media/Bookmarked.1cebe9c6.svg";